/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import moment from "moment";

interface Nfe {
  serie: number;
  nfe: number;
  dhemi: string;
  nome: string;
  cpf: string;
  cfop: string | null;
  vnfe: number;
  finalidade: string;
  status: string;
}

async function RelatorioNfce(dados: Nfe[], periodo: string) {

  const totalGeral = dados.reduce(
    (acc, item) => acc + (item?.vnfe ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((r) => {
    linhas.push([
      {
        text: moment(r.dhemi).format("DD/MM/YYYY"),
        fontSize: 8
      },
      {
        text: String(r.serie),
        fontSize: 8,
        alignment: "left"
      },
      {
        text: String(r.nfe),
        fontSize: 8,
        alignment: "left"
      },
      {
        text: r.status,
        fontSize: 8,
        alignment: "left",
        color: (() => {
          switch (r.status) {
            case "Cancelada":
              return "red";
            case "Lançada":
              return "#1976d2";
            case "Autorizada":
              return "green";
            default:
              return "black";
          }
        })()
      },
      {
        text: formatMoney(r.vnfe),
        alignment: "right",
        bold: true,
        fontSize: 8
      }
    ]);
  });

  const documentDefinition: any = {
    pageSize: "A4",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE NOTAS FISCAIS (NFC-e)",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {
          headerRows: 1,
          widths: [60, 40, "*", 40, 50],

          body: [

            [
              { text: "Data", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Série", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "NFC-e", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Status", bold: true, fillColor: "#e5e7eb", fontSize: 8 },
              { text: "Valor", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 }
            ],

            ...linhas
          ]
        },

        layout: {

          fillColor: function (rowIndex: number) {
            if (rowIndex === 0) return null;
            return rowIndex % 2 === 0 ? "#f9fafb" : null;
          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0
        }
      },

      {
        text: "TOTAL GERAL: " + formatMoney(totalGeral),
        alignment: "right",
        bold: true,
        fontSize: 11,
        margin: [0, 15, 0, 0]
      }
    ]
  };

  pdfMake.createPdf(documentDefinition).open();
}

function formatMoney(value: number) {
  const v = Number(value ?? 0);

  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));
}

export default RelatorioNfce;